import cn from 'classnames';
import { Fragment } from 'react/jsx-runtime';
import { Card } from '../../../../../../components/card/card';
import { Loader } from '../../../../../../components/loader/loader';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { ShiftsGridDaily } from './shifts-grid-daily/shifts-grid-daily';
import { ShiftsGridMonthly } from './shifts-grid-monthly/shifts-grid-monthly';
import { ShiftsGridShiftEmployeeModal } from './shifts-grid-shift-employee-modal/shifts-grid-shift-employee-modal';
import { ShiftsGridWeekly } from './shifts-grid-weekly/shifts-grid-weekly';
import s from './shifts-grid.module.css';
import { useShiftsGrid } from './use-shifts-grid';

export const ShiftsGrid = () => {
  const {
    t,
    cols,
    handleCloseShiftModal,
    handleOpenShiftModal,
    isOpenShiftModal,
    period,
    getColLabel,
    getLocale,
    isLoading,
    employeesByRoleWithShifts,
    isImport,
  } = useShiftsGrid();

  if (!cols.length) return t('Выберите Вид');

  return (
    <Card className={s.feature} style={{ gridTemplateColumns: `repeat(${cols.length + 1}, 1fr)` }}>
      {isLoading && <Loader />}
      <div className={s.header} />
      {cols.map(({ date, isWeekend }) => {
        return (
          <div key={date} className={cn(s.header, period !== 'day' && isWeekend && s.weekend)}>
            {getColLabel(date)}
            {/* {period === 'week' && (
              <div className={s.group}>
                <GroupIcon /> {slotShifts?.length || 0}
              </div>
            )} */}
          </div>
        );
      })}
      {Object.entries(employeesByRoleWithShifts).map(([role, employees]) => {
        if (!employees.length) return null;

        return (
          <Fragment key={role}>
            <span className={s.role}>{role}</span>
            {Array.from({ length: cols.length }).map((_, index) => (
              <div className={s.header} key={index} />
            ))}
            <Fragment>
              {employees.map((employee, index) => {
                const employeeName = `${getLocale(employee.name)} ${getLocale(employee.surname)}`;
                return (
                  <Fragment key={employee.id}>
                    <span className={cn(s.name, s[period])}>{employeeName}</span>
                    {cols.map(({ date }) => {
                      return (
                        <div key={`${employee.id}-${date}`} className={cn(s.cell, s[period])}>
                          {period === 'day' && (
                            <ShiftsGridDaily
                              employee={employee}
                              date={date}
                              index={Object.keys(employeesByRoleWithShifts).length - index + 1}
                              onClick={handleOpenShiftModal}
                            />
                          )}
                          {period === 'week' && (
                            <ShiftsGridWeekly
                              employee={employee}
                              date={date}
                              onClick={handleOpenShiftModal}
                            />
                          )}
                          {period === 'month' && (
                            <ShiftsGridMonthly
                              employee={employee}
                              date={date}
                              onClick={handleOpenShiftModal}
                            />
                          )}
                        </div>
                      );
                    })}
                  </Fragment>
                );
              })}
            </Fragment>
          </Fragment>
        );
      })}

      {!isImport && (
        <HasAccess service="staff" permissions={['write']}>
          {isOpenShiftModal && <ShiftsGridShiftEmployeeModal onClose={handleCloseShiftModal} />}
        </HasAccess>
      )}
    </Card>
  );
};
